import React from "react";
import { Flex } from "@theorgchartdev/storybook";

/**
 * A styled card component to display plan details summary information
 */
const PlanDetailsSummaryCard = ({ children }) => {
  return (
    <div className="ocn-plan-details-summary-card">
      <Flex direction="column" gap="8px">
        {children}
      </Flex>
    </div>
  );
};

export default PlanDetailsSummaryCard;
